import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'numeroAvvisoDescription',
    pure: true,
    standalone: false
})
export class NumeroAvvisoDescriptionPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  // CR 10/2024: il portale accetta solo NUMERO AVVISO di 18 caratteri e quindi non ci deve essere più la gestione, label e controlli, dei IUV
  transform(value: string | null | undefined): string {
    const numeroAvviso = this.translateService.instant('numero-avviso');
    // const iuv = this.translateService.instant('iuv');
    return numeroAvviso;
    //return value?.length === 18 ? numeroAvviso : iuv;
  }
}
